import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import ExcelJS from 'exceljs';
import Typography from '@material-ui/core/Typography';

import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {
    Box,
    Tooltip,
    Chip,
    Avatar,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    OutlinedInput
} from '@mui/material';

import RouterIcon from '@mui/icons-material/Router';
import SpeakerIcon from '@mui/icons-material/SurroundSound';
import HomeIcon from '@mui/icons-material/Home';
import BadgeIcon from '@mui/icons-material/Badge';
import MemoryIcon from '@mui/icons-material/Memory';
import SecurityIcon from '@mui/icons-material/Security';
import VideocamIcon from '@mui/icons-material/Videocam';
import SensorsIcon from '@mui/icons-material/Sensors';
import StorageIcon from '@mui/icons-material/Storage';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';


import api from '../../../../services/api';
import NavegadorGestao from "../../../../components/NavBarGestao";

import EditIcon from '@mui/icons-material/Edit';

import { Button } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';


import {
    MaterialReactTable,

} from 'material-react-table';




export default function Equipamentos() {



    const [loading, setLoading] = useState(true);
    const [objetos, setObjetos] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnFilters, setColumnFilters] = useState([]);
    const [tiposSelecionados, setTiposSelecionados] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });


    const processarTipoEquipamento = (tipo) => {
        let texto = "";
        switch (tipo) {
            case 0: texto = "PGM"; break;
            case 10: texto = "MEDIDOR DE CONSUMO"; break;
            case 20: texto = "CONTROLADOR DE ACESSO"; break;
            case 30: texto = "MÓDULO SONORO"; break;
            case 40: texto = "FONTE VDC"; break;
            case 70: texto = "CENTRAL"; break;
            case 80: texto = "CÂMERA"; break;
            case 90: texto = "SENSOR"; break;
            case 100: texto = "DVR"; break;
            case 110: texto = "NVR"; break;
            case 120: texto = "ALTO FALANTE SIP"; break;
            case 130: texto = "TELEFONE SIP"; break;
            default: texto = "DESCONHECIDO"; break;
        }
        return texto;
    }

    async function listarObjetos() {
        if (!objetos.length) {
            setLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            const response = await api.get("v1/protected/equipamentos/listartodospaginado", {
                headers,
                params: {
                    busca: globalFilter || '',
                    tipos: tiposSelecionados.length > 0 ? tiposSelecionados.join(',') : null,
                    size: pagination.pageSize,
                    page: pagination.pageIndex,
                }
            });

            const updatedData = response.data.dados.map(item => {
                item.tipo_equipamento_str = processarTipoEquipamento(item.tipo_equipamento);
                return item;
            });

            setObjetos(updatedData);
            setRowCount(response.data.total || 0);
            setLoading(false);
            setIsRefetching(false);
            setIsError(false);

        } catch (_err) {
            console.log("Erro ao listar objetos: " + _err);
            setLoading(false);
            setIsRefetching(false);
            setIsError(true);
        }
    }

    const getTipoIcon = (tipo) => {
        switch (tipo) {
            case 0: return <MemoryIcon fontSize="small" />;
            case 10: return <SettingsInputComponentIcon fontSize="small" />;
            case 20: return <BadgeIcon fontSize="small" />;
            case 30: return <VolumeUpIcon fontSize="small" />;
            case 40: return <SettingsInputComponentIcon fontSize="small" />;
            case 70: return <SecurityIcon fontSize="small" />;
            case 80: return <VideocamIcon fontSize="small" />;
            case 90: return <SensorsIcon fontSize="small" />;
            case 100:
            case 110: return <StorageIcon fontSize="small" />;
            case 120: return <SpeakerIcon fontSize="small" />;
            case 130: return <PhoneInTalkIcon fontSize="small" />;
            default: return <RouterIcon fontSize="small" />;
        }
    }

    useEffect(() => {
        listarObjetos();
    }, [pagination.pageIndex, pagination.pageSize, globalFilter, columnFilters, tiposSelecionados]);


    const handleExportRows = (rows) => {
        const doc = new jsPDF();
        const tableData = rows.map((row) => {
            const rowData = [];
            row.getVisibleCells().forEach((cell) => {
                const colId = cell.column.id;
                // Ignora coluna de ações (MRT_TableBodyCellRowActions)
                if (colId !== 'mrt-row-actions') {
                    if (colId === 'instalacao_nome') {
                        rowData.push(row.original.instalacao?.nome + '\n' + row.original.instalacao?.endereco);
                    } else if (colId === 'tipo_equipamento_str') {
                        rowData.push(row.original.tipo_equipamento_str);
                    } else {
                        rowData.push(cell.getValue());
                    }
                }
            });
            return rowData;
        });

        const tableHeaders = rows[0].getVisibleCells()
            .filter(cell => cell.column.id !== 'mrt-row-actions')
            .map((cell) => cell.column.columnDef.header);

        autoTable(doc, {
            head: [tableHeaders],
            body: tableData,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [63, 81, 181] },
        });

        doc.save('equipamentos.pdf');
    };

    const handleExportExcel = async (rows) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Equipamentos');

        // Extrair cabeçalhos e IDs de coluna (ignorando ações e colunas sem cabeçalho/sistema)
        const visibleColumns = rows[0].getVisibleCells()
            .filter(cell =>
                cell.column.id !== 'mrt-row-actions' &&
                cell.column.id !== 'mrt-row-select' &&
                cell.column.id !== 'mrt-row-expand' &&
                cell.column.columnDef.header // Garante que a coluna tem um nome
            );

        const headers = visibleColumns.map(cell => cell.column.columnDef.header);
        const columnIds = visibleColumns.map(cell => cell.column.id);

        // Mapear dados das linhas
        const tableData = rows.map((row) => {
            return columnIds.map(colId => {
                if (colId === 'instalacao.nome') {
                    return row.original.instalacao?.nome || '';
                } else if (colId === 'tipo_equipamento_str') {
                    return row.original.tipo_equipamento_str;
                } else {
                    const cell = row.getVisibleCells().find(c => c.column.id === colId);
                    return cell ? cell.getValue() : '';
                }
            });
        });

        // Adicionar tabela ao Excel
        worksheet.addTable({
            name: 'Equipamentos',
            ref: 'A1',
            headerRow: true,
            totalsRow: false,
            style: {
                showRowStripes: true,
            },
            columns: headers.map(header => ({ name: header, filterButton: true })),
            rows: tableData,
        });

        // Estilizar Cabeçalho Manualmente (fundo preto, texto branco)
        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF000000' }
            };
            cell.font = {
                color: { argb: 'FFFFFFFF' },
                bold: true
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Ajustar largura das colunas e centralizar dados
        worksheet.columns.forEach((column, i) => {
            let maxLen = headers[i].length;
            tableData.forEach(row => {
                const val = row[i];
                const len = val ? val.toString().length : 0;
                if (len > maxLen) maxLen = len;
            });
            column.width = maxLen < 15 ? 20 : maxLen + 10; // Aumentado conforme solicitado
        });

        // Gerar o arquivo e disparar download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'equipamentos.xlsx';
        anchor.click();
        window.URL.revokeObjectURL(url);
    };





    const handleClickEditarEquipamento = (row) => {
        window.location.href = "/gestao/administracao/equipamentos/editarequipamento/" + row.original.id_equipamento + "/1/0/0";
    };




    const columns = useMemo(
        () => [
            {
                accessorKey: 'id_equipamento',
                header: 'ID',
                size: 60,
                muiTableBodyCellProps: {
                    sx: { fontSize: '0.75rem' },
                },
            },
            {
                accessorKey: 'instalacao.nome',
                header: 'Instalação',
                size: 300,
                Cell: ({ row }) => (
                    <Tooltip title={row.original.instalacao?.endereco || "Sem endereço"} arrow placement="top">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            <LocationCityIcon color="action" fontSize="small" />
                            <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, lineHeight: 1.2 }}>
                                {row.original.instalacao?.nome}
                            </Typography>
                        </Box>
                    </Tooltip>
                ),
            },
            {
                accessorKey: 'tipo_equipamento_str',
                header: 'Tipo',
                size: 180,
                Cell: ({ row }) => (
                    <Chip
                        icon={getTipoIcon(row.original.tipo_equipamento)}
                        label={row.original.tipo_equipamento_str}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: '0.65rem', height: '20px' }}
                    />
                ),
            },
            {
                accessorKey: 'ramal',
                header: 'Ramal',
                size: 100,
                Cell: ({ renderedCellValue }) => renderedCellValue ? (
                    <Chip
                        label={renderedCellValue}
                        color="primary"
                        size="small"
                        sx={{ fontSize: '0.65rem', height: '20px', fontWeight: 'bold' }}
                    />
                ) : null,
            },
            {
                accessorKey: 'nome_mapa',
                header: 'Nome Mapa',
                size: 150,
                muiTableBodyCellProps: {
                    sx: { fontSize: '0.75rem' },
                },
            },
            {
                accessorKey: 'localizacao',
                header: 'Localização',
                size: 150,
                muiTableBodyCellProps: {
                    sx: { fontSize: '0.75rem' },
                },
            },
            {
                accessorKey: 'ip',
                header: 'IP',
                size: 120,
                Cell: ({ renderedCellValue }) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <NetworkCheckIcon fontSize="inherit" style={{ fontSize: '12px' }} />
                        <Typography sx={{ fontSize: '0.75rem' }}>{renderedCellValue}</Typography>
                    </Box>
                )
            },
            {
                accessorKey: 'porta',
                header: 'Porta',
                size: 80,
                muiTableBodyCellProps: {
                    sx: { fontSize: '0.75rem' },
                },
            },
        ],
        [],
    );



    return (
        <div>

            <NavegadorGestao
                BaseDados={true}
                Clientes={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />

            <div style={{ padding: 5 }}>

                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <div>
                        {objetos && (
                            <MaterialReactTable
                                columns={columns}
                                data={objetos}
                                enableGlobalFilterModes
                                enablePagination={true}
                                enableRowActions
                                manualPagination={true}
                                onPaginationChange={setPagination}
                                onGlobalFilterChange={setGlobalFilter}
                                onColumnFiltersChange={setColumnFilters}
                                rowCount={rowCount}
                                state={{
                                    pagination,
                                    globalFilter,
                                    columnFilters,
                                    isLoading: loading,
                                    showAlertBanner: isError,
                                    showProgressBars: isRefetching,
                                }}
                                paginationDisplayMode={'pages'}
                                getRowId={(row) => row.id_equipamento}
                                enableTopToolbar={true}
                                enableBottomToolbar={true}
                                enableColumnFilters={true}
                                enableColumnActions={false}
                                sortable={true}
                                enableSorting={true}
                                enableRowSelection={false}
                                enableColumnFilterModes={true}
                                enableExpandAll={true}
                                enableColumnPinning={true}
                                enableColumnResizing={true}
                                enableStickyHeader={true}
                                enableStickyFooter={true}
                                initialState={{
                                    showGlobalFilter: true,
                                    density: 'compact',
                                }}
                                muiTableContainerProps={{
                                    sx: {
                                        height: 'calc(100vh - 180px)', // Ajustado para considerar navbar e toolbars
                                        maxHeight: 'calc(100vh - 180px)'
                                    }
                                }}
                                muiPaginationProps={{
                                    rowsPerPageOptions: [50, 100, 200, 500],
                                    variant: 'outlined',
                                }}
                                enableFullScreenToggle={true}
                                renderTopToolbarCustomActions={({ table }) => (
                                    <Box sx={{ display: 'flex', gap: '1rem', p: '4px', alignItems: 'center' }}>
                                        <FormControl sx={{ minWidth: 200 }} size="small">
                                            <InputLabel id="label-tipo-multi">Filtrar por Tipo</InputLabel>
                                            <Select
                                                labelId="label-tipo-multi"
                                                id="tipo-multi-select"
                                                multiple
                                                value={tiposSelecionados}
                                                onChange={(e) => setTiposSelecionados(e.target.value)}
                                                input={<OutlinedInput label="Filtrar por Tipo" />}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => (
                                                            <Chip
                                                                key={value}
                                                                label={processarTipoEquipamento(value)}
                                                                size="small"
                                                                sx={{ height: 20, fontSize: '0.6rem' }}
                                                            />
                                                        ))}
                                                    </Box>
                                                )}
                                                MenuProps={{ PaperProps: { style: { maxHeight: 400 } } }}
                                            >
                                                {[0, 10, 20, 30, 40, 70, 80, 90, 100, 110, 120, 130].map((tipoId) => (
                                                    <MenuItem key={tipoId} value={tipoId}>
                                                        <Checkbox checked={tiposSelecionados.indexOf(tipoId) > -1} size="small" />
                                                        <ListItemText primary={processarTipoEquipamento(tipoId)} primaryTypographyProps={{ fontSize: '0.75rem' }} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <Button
                                            color="secondary"
                                            onClick={() => handleExportRows(table.getRowModel().rows)}
                                            variant="contained"
                                            startIcon={<PictureAsPdfIcon />}
                                            style={{ fontSize: 10, height: 38 }}
                                        >
                                            Exportar PDF
                                        </Button>

                                        <Button
                                            color="primary"
                                            onClick={() => handleExportExcel(table.getRowModel().rows)}
                                            variant="contained"
                                            startIcon={<RouterIcon />} // Usando RouterIcon como fallback para ícone de planilha/rede
                                            style={{ fontSize: 10, height: 38 }}
                                        >
                                            Exportar Excel
                                        </Button>
                                    </Box>
                                )}
                                renderRowActions={({ row }) => (
                                    <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                                        <Tooltip title="Gerenciar">
                                            <IconButton color="error" onClick={() => handleClickEditarEquipamento(row)}>
                                                <SettingsIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                )}
                            />
                        )}


                    </div>
                }


            </div>




        </div>
    );
}



